import * as campaignActions from '../campaign/store/campaignActions';
import { pageTypesStrings } from '../../constants/pageTypes';

export const getPageIdForRow = (item: any): number | null => {
  if (!item) return null;
  switch (item.type) {
    case pageTypesStrings.TEAM:
      return item.teamId ?? item.id ?? null;
    case pageTypesStrings.COLLECTION:
      return item.collectionId ?? item.id ?? null;
    default:
      return item.fundraiserId ?? item.id ?? null;
  }
};

export const getMarkSpamModalConfigForRow = (item: any) => {
  const pageType = item?.type || pageTypesStrings.FUNDRAISER;
  const getRecord =
    pageType === pageTypesStrings.TEAM
      ? campaignActions.getTeamRecord
      : pageType === pageTypesStrings.COLLECTION
        ? campaignActions.getCollectionRecord
        : campaignActions.getFundraiserRecord;
  const translationBase =
    pageType === pageTypesStrings.TEAM
      ? 'team.view'
      : pageType === pageTypesStrings.COLLECTION
        ? 'collection.view'
        : 'fundraiser.fundraiser-view';
  return { pageType, getRecord, translationBase };
};

export const normalizeRowAsSpamEntity = (item: any) => {
  if (!item) return null;
  return {
    ...item,
    manager:
      item.manager ||
      (item.account
        ? {
            id: item.account.id,
            firstName: item.account.firstName,
            lastName: item.account.lastName,
            email: item.account.email
          }
        : null)
  };
};
